import React, { Component, Fragment } from 'react'
import '../../styles/Popup.module.css'
import { Form, Input, message } from 'antd';
import { connect } from 'react-redux';
import { requestServerPost, selectPage } from '../../actions';
import PopupManager from '../../managers/PopupManager';
import { LayoutTemplate } from 'lucide-react';

const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
};


class CreateLayoutTemplatePage extends Component {
    constructor(props) {
        super(props);
        this.state = { fileList: [] };
    }

    normFile = e => {
        // console.log('Upload event:', e);
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    onChange = ({ fileList: newFileList }) => {
        // console.log("onChange " + JSON.stringify(newFileList))
        this.setState({ fileList: newFileList });
    };


    onPreviewDrop = (files) => {
        this.setState({
            files: this.state.fileList.concat(files),
        });
    }

    onPreview = async file => {
        let src = file.url;
        if (!src) {
            src = await new Promise(resolve => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow.document.write(image.outerHTML);
    };

    onFinish = values => {
        const { requestServerPost, usertoken, selectedBrandData, data = null, onTemplateCreated = () => { }, template = null } = this.props;
        var params = new FormData();

        if (!template) {
            message.warn("No template data to save");
            return;
        }

        template.layout_name = values.templatename;
        const templateString = JSON.stringify(template);

        if (data) {
            params.append("layouttemplateid", data.LayoutTemplateID);
            params.append("templatename", values.templatename);
            params.append("template", templateString);
            requestServerPost("update_layouttemplate", params, {}, (response) => {

                onTemplateCreated();
                // console.log("create brand success")
                // PopupManager.closePopup();
            }, usertoken);
        }
        else {

            params.append("brandid", selectedBrandData.BrandID);
            params.append("templatename", values.templatename);
            params.append("template", templateString);
            requestServerPost("create_layouttemplate", params, {}, (response) => {

                // console.log(JSON.stringify(response))
                onTemplateCreated();
                // onTemplateCreated(response.data.playlistid)
                // console.log("create brand success")  
                // PopupManager.closePopup();
            }, usertoken);
        }
    };

    render() {
        const { requestServerPost, usertoken, selectedBrandData, data = null } = this.props;
        const previewStyle = {
            display: 'inline',
            width: 100,
            height: 100,
        };
        const bleed = { margin: -24, overflow: 'hidden' };
        const body = { maxWidth: 440, margin: '0 auto', padding: '32px 40px' };

        return (
            <div style={{ ...bleed }}>
                <div style={{ background: 'linear-gradient(135deg,#6366f1 0%,#4f46e5 100%)', padding: '36px 40px', textAlign: 'center', color: '#fff' }}>
                    <div style={{ width: 56, height: 56, borderRadius: 16, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>
                        <LayoutTemplate size={28} color="#fff" />
                    </div>
                    <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>{data ? 'Edit Layout Template' : 'Create a Layout Template'}</div>
                    <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.75)' }}>Name your layout template to get started</div>
                </div>
                <div style={{ ...body }}>
                    <Form name="create_layout_template_form" {...formItemLayout} onFinish={this.onFinish}
                        initialValues={{ templatename: data ? data.PlaylistName : '' }}>
                        <div style={{ marginBottom: 28 }}>
                            <label style={{ fontSize: 12, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: 6 }}>Template Name</label>
                            <Form.Item name="templatename" style={{ marginBottom: 0 }} rules={[{ required: true, message: 'Please enter a template name' }]}>
                                <Input size="large" placeholder="e.g. 3-Zone Landscape" style={{ borderRadius: 10 }} autoFocus />
                            </Form.Item>
                        </div>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <button type="submit" style={{ width: '100%', height: 48, borderRadius: 10, border: 'none', background: 'linear-gradient(135deg,#6366f1,#4f46e5)', color: '#fff', fontSize: 15, fontWeight: 600, cursor: 'pointer', boxShadow: '0 2px 10px rgba(99,102,241,0.3)' }}>
                                {data ? 'Save Changes' : 'Create Template'}
                            </button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        );
    }
}

const Styles = {

}


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerPost, requestServerPost, selectPage })(CreateLayoutTemplatePage);
